import { CARRIER_INTEGRATIONS_ACTIONS } from './carrierIntegrations.types'

/**
 * @param {Array} payload
 * @returns {Object}
 */
export const setCarrierIntegrationsAction = payload => ({
  type: CARRIER_INTEGRATIONS_ACTIONS.SET_CARRIER_INTEGRATIONS,
  payload
})

/**
 * @param {import('../slice.types').SliceStatus} payload
 * @returns {Object}
 */
export const setCarrierIntegrationsStatusAction = payload => ({
  type: CARRIER_INTEGRATIONS_ACTIONS.SET_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {Object}
 */
export const setCarrierIntegrationsErrorsAction = payload => ({
  type: CARRIER_INTEGRATIONS_ACTIONS.SET_ERRORS,
  payload
})

/**
 * @returns {Object}
 */
export const clearCarrierIntegrationsErrorsAction = () => ({
  type: CARRIER_INTEGRATIONS_ACTIONS.CLEAR_ERRORS
})
